import { LinkProps, Link as ChakraLink } from "@chakra-ui/react";
import { Theme, useTheme } from "@emotion/react";

function Link({ children, ...props }: LinkProps) {
  const theme: Theme & {
    nextLink?: any;
  } = useTheme();

  return (
    <ChakraLink as={theme.nextLink || "a"} {...props} passHref shallow>
      {children}
    </ChakraLink>
  );
}

export default Link;
